///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/service-categories.collection.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ServiceCategoriesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected serviceCategories: ServiceCategoriesCollection;
        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.serviceCategories;
        }

        get totalSelectedCount(): number {
            return this.serviceCategories.value.length;
        }

        constructor(model: Dictionary<any>, protected properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.serviceCategories = new ServiceCategoriesCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
            });

            this.title = 'LABEL_SERVICE_CATEGORIES';
            this.allSelectedLabel = 'LABEL_ALL_SERVICE_CATEGORIES';
            this.totalSelectedMessage = 'LABEL_TOTAL_SERVICE_CATEGORIES_SELECTED';

            if (options.required) {
                this.validation.push(new RequiredValidation(this.collection, 'LABEL_RESTRICT_SERVICE_FROM_TRANSFER_REQUIRED'));
            }
        }

        onCriteriaUpdate(newCriteria: _.Dictionary<any>, $q: angular.IQService): angular.IPromise<any> {
            this.serviceCategories.updateCriteria(newCriteria);
            return this.serviceCategories.fetch();
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);
            this.serviceCategories.setWatchers(scope);
        }
    }
}